import { useCallback, useEffect, useState, createRef } from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Link } from '@ta-interaktiv/contentbricks'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'

const GridItem = ({
  tenant,
  colorMode,
  title,
  titleMobile,
  image,
  caption,
  name,
  party,
  text,
  className,
}: {
  tenant?: object
  colorMode?: string
  title?: string
  titleMobile?: string
  image?: string
  caption?: string
  name: string
  party: string
  text: string
  className?: string
}) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isSmallMobile, setIsSmallMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 1024)
    setIsSmallMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Griditem className='test'>
      {className === 'odd' && (
        <div className={'top ' + className + ' ' + party.toLowerCase()}>
          <div className='left'>
            <div className='photo'>
              <img
                src={require(`./images/${image}.png`)}
                alt={name}
                className={party}
              />
              <div className='caption'>{caption}</div>
            </div>
          </div>

          <div className='right'>
            {/* <h3
              dangerouslySetInnerHTML={{
                __html: isSmallMobile ? titleMobile : title,
              }}
            /> */}
            <div className='info'>
              <h4 dangerouslySetInnerHTML={{ __html: name }} />
              <div className='party'>
                <span>{party}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {className === 'even' && (
        <div className={'top ' + className + ' ' + party.toLowerCase()}>
          <div className='left'>
            {/* <h3
              dangerouslySetInnerHTML={{
                __html: isSmallMobile ? titleMobile : title,
              }}
            /> */}
            <div className='info'>
              <h4 dangerouslySetInnerHTML={{ __html: name }} />
              <div className='party'>
                <span>{party}</span>
              </div>
            </div>
          </div>

          <div className='right'>
            <div className='photo'>
              <img
                src={require(`./images/${image}.png`)}
                alt={name}
                className={party}
              />
              <div className='caption'>{caption}</div>
            </div>
          </div>
        </div>
      )}
      <div
        className={colorMode === 'dark' ? 'text dark' : 'text'}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 1.8rem;
  margin-bottom: 3.4rem;

  :last-child {
    border-bottom: none;
  }

  h3 {
    margin-top: 2.2rem;
    font-size: 2.5rem;
    line-height: 3.6rem;
    font-family: var(--font-serif);
    @media only screen and (max-width: 600px) {
      font-size: 2.1rem;
      line-height: 2.8rem;
    }
    font-weight: 400;
  }
  .info {
    /* bottom: 6rem;
    position: absolute; */
    h4 {
      margin: 0;
      font-family: var(--font-sans-serif);
      font-size: 2rem;
      @media only screen and (max-width: 600px) {
        font-size: 2rem;
      }
      line-height: 2.4rem;
      font-weight: 600;
      margin-bottom: 0.3rem;
      @media only screen and (max-width: 600px) {
        margin-bottom: 0.3rem;
      }
    }
    .party {
      font-size: 1.7rem;
      @media only screen and (max-width: 600px) {
        font-size: 1.7rem;
      }
    }
  }
  .photo {
    position: relative;
    display: flex;

    /* margin-bottom: 1.4rem; */

    img {
      border-radius: 50%;
      width: 100%;
      margin-bottom: 0;

      &.SVP {
        background-color: #4b8a3e;
      }
      &.FDP {
        background-color: rgb(56, 114, 181);
      }

      &.SP {
        background-color: rgb(240, 85, 77);
      }

      &.GLP {
        background-color: #c4c43d;
      }

      &.EVP {
        background-color: #e6c820;
      }

      &.Grüne,
      &.Gruene {
        background-color: #83b547;
      }

      /* border-bottom: 8px solid grey; */
    }
  }
  .caption {
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 2rem;
    margin-top: 0;
    margin-bottom: 0;
    top: -0.6rem;
    position: relative;
  }
  .text {
    font-size: 1.75rem;
    text-align: left;
    font-family: var(--font-serif);
    a {
      cursor: pointer;
      color: inherit;
      text-decoration: none;
      padding: 0.2rem 0 0;
      white-space: normal;
    }

    a:hover,
    a:link,
    a:active,
    a:visited {
      background-image: linear-gradient(90deg, #ffe462, #ffe462);
      background-repeat: repeat-x;
      background-position: bottom;
      background-size: 100% 20%;
      transition: all 0.1s ease-in-out;
      color: var(--text-color);
      background-origin: content-box;
      text-decoration: none;
    }
    a:hover {
      background-size: 100% 100%;
      color: var(--brandblue-main);
    }
  }

  .party {
    span {
      padding: 0.2rem 0.6rem;
      font-weight: 600;
      color: #fff;
    }
  }

  .mitte {
    .party span {
      background-color: rgb(214, 134, 43);
    }
    .photo img {
      border-color: rgb(214, 134, 43);
    }
  }
  .fdp {
    .party span {
      background-color: rgb(56, 114, 181);
    }
    .photo img {
      border-color: rgb(56, 114, 181);
    }
  }
  .svp {
    .party span {
      background-color: #4b8a3e;
    }
    .photo img {
      border-color: #4b8a3e;
    }
  }
  .sp {
    .party span {
      background-color: rgb(240, 85, 77);
    }
    .photo img {
      border-color: rgb(240, 85, 77);
    }
  }
  .grüne {
    .party span {
      background-color: #83b547;
    }
    .photo img {
      border-color: #83b547;
    }
  }
  .glp {
    .party span {
      background-color: #c4c43d;
    }
    .photo img {
      border-color: #c4c43d;
    }
  }
  .evp {
    .party span {
      background-color: #e6c820;
    }
    .photo img {
      border-color: #e6c820;
    }
  }
  .edu {
    .party span {
      background-color: #a65e42;
    }
    .photo img {
      border-color: #a65e42;
    }
  }

  .top {
    display: grid;
    position: relative;
  }

  .top.odd {
    grid-template-columns: 30% 70%;
    margin-bottom: 2rem;
    @media only screen and (max-width: 600px) {
      grid-template-columns: 33% 67%;
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 2.2rem;
      @media only screen and (max-width: 600px) {
        padding-left: 1.4rem;
      }
      .info {
        /* width: 70%;
        @media only screen and (max-width: 600px) {
          width: 60%;
        } */
      }
    }

    /* .party {
      right: 4%;
      left: unset;
    } */
  }

  .top.even {
    grid-template-columns: 70% 30%;
    margin-bottom: 2rem;
    @media only screen and (max-width: 600px) {
      grid-template-columns: 67% 33%;
    }
    text-align: right;

    .left {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 2.2rem;
      @media only screen and (max-width: 600px) {
        padding-right: 1.4rem;
      }
      .info {
        /* width: 70%;
        @media only screen and (max-width: 600px) {
          width: 60%;
        } */
        /* h4,
        .party {
          padding-right: 2.2rem;
          @media only screen and (max-width: 600px) {
            padding-right: 1rem;
          }
        } */
      }
    }
  }

  //Link

  .text {
    &.dark {
      a.external-link:after {
        filter: brightness(0) invert(1);
      }
    }
    a.external-link:after {
      font-family: 'custom_icons';
      content: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='12px' height='14px' view-box='0 0 12 14'%3E%3Ctitle%3E1 Element/Icon/14/External_Story Link_narrow@1.5x%3C/title%3E%3Cg id='1-Element/Icon/14/External_Story-Link_narrow' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' %3E%3Cg id='Group-2' transform='translate(0.000000, -0.000000)'%3E%3Crect id='Size' x='0' y='0' width='12' height='14' /%3E%3Cg id='Group' transform='translate(2.812816, -0.000000)' fill='currentColor'%3E%3Crect id='Rectangle' x='2.18718434' y='0' width='7' height='1.5' /%3E%3Crect id='Rectangle' transform='translate(4.419417, 4.819417) rotate(-45.000000) translate(-4.419417, -4.819417) ' x='-1.08058262' y='4.06941738' width='11' height='1.5' /%3E%3Crect id='Rectangle' x='7.68718434' y='0' width='1.5' height='7' /%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      margin-left: 0.25em;
      color: var(--text-color);
    }
  }

  /* a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    padding: 0.2rem 0 0;
    white-space: nowrap;
    background-image: linear-gradient(
      to right,
      var(--yellow-main) 0,
      var(--yellow-main) 100%
    );
    background-size: 100% 20%;
    background-position-y: 17px;
    background-repeat: repeat-x;
    background-position: bottom;
  }

  a.link:hover,
  a.link:link,
  a.link:active,
  a.link:visited {
    background-image: linear-gradient(90deg, #ffe462, #ffe462);
    background-repeat: repeat-x;
    background-position: bottom;
    background-size: 100% 20%;
    transition: all 0.1s ease-in-out;
    color: var(--text-color);
    background-origin: content-box;
  }
  a.link:hover {
    background-size: 100% 100%;
  } */
`

export default GridItem
